export const PROFILE = {
  name: "MD Nurul Islam Sumon",
  shortName: "Sumon",
  tagline: "Digital Marketer · Affiliate Strategist · Web Developer",
  freelancerId: "F126108520070",
  verifyUrl:
    "https://www.freelancers.gov.bd/verify/7b7b0d92-b00d-4141-87ff-321bd1853807-sh-1768997515-y-b12bd934ec96b9dd2277dc64c32abb9982582ae4-a-m-0a6510ec3bde1522fabf64c152824d3f3dc47de7",
  whatsapp: "https://wa.me/8801722515774",
  email: "isrum.egg@gmail.com",
  linkedin: "https://www.linkedin.com/in/iamnurul/",
  website: "https://imnurul.com",
  idCardUrl: "https://imnurul.com/ID/FreelancerID.pdf",
  portrait:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_banabo-bio/artifacts/rm9jtafi_DSC_7651-Edit-Edit.webp",
  workspace:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_banabo-bio/artifacts/8vjqwwv8_WhatsApp%20Image%202026-07-04%20at%2012.37.50%20PM.jpeg",
};

export const STATS = [
  { value: "300+", label: "Projects Delivered" },
  { value: "$10K+", label: "Revenue Earned" },
  { value: "134", label: "Happy Clients" },
];

export const SERVICES = [
  {
    id: "digital-marketing",
    num: "01",
    title: "Digital Marketing",
    desc: "Full-funnel growth engines on Meta & Google. Every taka tracked, every campaign accountable to revenue.",
    points: ["Meta & Google Ads", "Funnel Optimization", "ROI Scaling", "Analytics & Tracking"],
    icon: "megaphone",
  },
  {
    id: "affiliate-marketing",
    num: "02",
    title: "Affiliate Marketing",
    desc: "CPA strategy and traffic arbitrage that turns cold clicks into commissions — landing pages built to convert.",
    points: ["CPA Strategy", "Lead Generation", "High-Converting Landing Pages", "Traffic Arbitrage"],
    icon: "link",
  },
  {
    id: "web-development",
    num: "03",
    title: "Website Development",
    desc: "Fast, beautiful, conversion-first websites — from custom React builds to WordPress that actually ranks.",
    points: ["React / Next.js", "Custom WordPress", "Speed Optimization", "E-Commerce"],
    icon: "code",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Data over guesswork",
    body: "Every campaign starts with numbers, not opinions. I test, measure, and scale only what proves itself in revenue.",
  },
  {
    num: "02",
    title: "Code meets growth",
    body: "A marketer who can build, and a developer who can sell. Strategy and execution live in the same pair of hands.",
  },
  {
    num: "03",
    title: "Verified, transparent trust",
    body: "Government-verified freelancer ID, open reporting, and honest timelines. You always know where your project stands.",
  },
];

export const MARQUEE_ITEMS = [
  "Meta Ads", "Google PPC", "SEO", "React", "Next.js", "WordPress", "CPA Networks",
  "Email Funnels", "Conversion Copy", "Analytics", "E-Commerce", "Landing Pages",
];

export const REVIEWS = [
  {
    name: "mschlabach",
    role: "Verified Client · Ongoing Collaboration",
    location: "United States",
    category: "Web Development",
    rating: 5,
    result: "$200–$400 · 1 day delivery",
    text: "Nurul and her team helped us get rid of malware on our site and do a full site inspection. She recommended new plugins and security measures on top of what we were doing to prevent it from happening again on our sites.",
  },
  {
    name: "brandyn845",
    role: "Verified Client",
    location: "United States",
    category: "Digital Marketing",
    rating: 5,
    result: "$50–$100 · 6 days delivery",
    text: "I had a good experience with this SEO backlinks service. My website needed more authority, and this gig helped me build a better backlink profile. The seller delivered the work clearly, and I was able to check the links without any confusion. Overall, I am happy with the service and the way the order was handled.",
  },
  {
    name: "koa1234",
    role: "Verified Client",
    location: "South Korea",
    category: "Web Development",
    rating: 5,
    result: "$100–$200 · 8 days delivery",
    text: "They worked very kindly and without any obstacles. The expertise stands out.",
  },
  {
    name: "daniel_weber",
    role: "eCommerce Store Owner",
    location: "Germany",
    category: "Digital Marketing",
    rating: 5,
    result: "2.8x ROAS on Meta campaigns",
    text: "Sumon rebuilt my Meta ad account from scratch — new creatives, new audiences, proper tracking. Within five weeks the campaigns were profitable at 2.8x ROAS. Communication was fast and every report was easy to understand.",
  },
  {
    name: "markpeters88",
    role: "Affiliate Publisher",
    location: "United Kingdom",
    category: "Affiliate Marketing",
    rating: 5,
    result: "CPA earnings up 2x in 60 days",
    text: "He audited my affiliate funnel and spotted tracking leaks I had missed for months. Fixed the landing pages, tightened the offers, and my CPA earnings doubled within two months. Straightforward and reliable.",
  },
  {
    name: "farhan_k",
    role: "Business Consultant",
    location: "United Arab Emirates",
    category: "Web Development",
    rating: 5,
    result: "PageSpeed 34 → 92 on WordPress",
    text: "My WordPress site was painfully slow and losing leads. Sumon optimized everything — PageSpeed went from 34 to 92 — and redesigned the landing flow. Delivered exactly on the promised date.",
  },
  {
    name: "emily.carter",
    role: "Clinic Marketing Manager",
    location: "Canada",
    category: "Digital Marketing",
    rating: 4,
    result: "38% lower cost per lead",
    text: "Google Ads was our most expensive channel before Sumon took over. He restructured campaigns and cut our cost per lead by 38% in one quarter. Only reason for 4 stars — I wish we had started sooner.",
  },
];

export const SKILLS = [
  { label: "Website Development", value: 80 },
  { label: "Digital Marketing", value: 95 },
  { label: "Affiliate Marketing", value: 100 },
];

export const PACKAGES = [
  {
    id: "landing-sprint",
    name: "Landing Sprint",
    price: "150",
    tagline: "A high-converting landing page, fast",
    features: ["Custom landing page design", "Mobile-first & speed optimized", "Basic SEO setup", "Delivered in 5 days"],
    featured: false,
  },
  {
    id: "growth-setup",
    name: "Growth Setup",
    price: "350",
    tagline: "Ads + funnel, ready to scale",
    features: ["Meta or Google Ads setup", "Conversion tracking & analytics", "Funnel audit & recommendations", "2 weeks of optimization"],
    featured: true,
  },
  {
    id: "growth-partner",
    name: "Growth Partner",
    price: "750",
    tagline: "Full stack of growth, monthly",
    features: ["Website + ads managed together", "Affiliate funnel engineering", "Weekly reporting & strategy calls", "Priority WhatsApp support"],
    featured: false,
  },
];

export const CASES = [
  {
    id: "ecom-growth",
    category: "Digital Marketing",
    title: "eCommerce Growth Engine",
    desc: "Full-funnel Meta ads rebuild for a fashion store — new creatives, fresh audiences, proper tracking.",
    metric: "3.1x ROAS in 6 weeks",
    image:
      "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYW5hbHl0aWNzJTIwZGFzaGJvYXJkJTIwd2Vic2l0ZSUyMGRldmVsb3BtZW50fGVufDB8fHx8MTc4ODI3MjA3M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "affiliate-funnel",
    category: "Affiliate Marketing",
    title: "Affiliate Funnel System",
    desc: "CPA funnel audit and landing page rebuild that plugged tracking leaks and lifted conversions.",
    metric: "2x earnings in 60 days",
    image:
      "https://images.unsplash.com/photo-1625296276703-3fbc924f07b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYW5hbHl0aWNzJTIwZGFzaGJvYXJkJTIwd2Vic2l0ZSUyMGRldmVsb3BtZW50fGVufDB8fHx8MTc4ODI3MjA3M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "web-rebuild",
    category: "Web Development",
    title: "Corporate Website Rebuild",
    desc: "A slow WordPress site rebuilt for speed, SEO, and a cleaner conversion flow.",
    metric: "PageSpeed 34 → 92",
    image:
      "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYW5hbHl0aWNzJTIwZGFzaGJvYXJkJTIwd2Vic2l0ZSUyMGRldmVsb3BtZW50fGVufDB8fHx8MTc4ODI3MjA3M3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const FAQS = [
  {
    q: "How long does a typical project take?",
    a: "Landing pages ship in about 5 days, full websites in 2–3 weeks, and ad campaigns usually go live within the first week. You always get a clear timeline before we start.",
  },
  {
    q: "Do you require advance payment?",
    a: "I take 50% to book your slot and the rest on final delivery. You can also pay securely through the PayPal packages on this site.",
  },
  {
    q: "How many revisions are included?",
    a: "Every design and development deliverable includes 2 free revision rounds. Marketing campaigns include ongoing optimization instead of revisions.",
  },
  {
    q: "Do you work with international clients?",
    a: "Yes — most of my clients are in the US, UK, Canada, and Korea. I work async-friendly with clear weekly reports, across any timezone.",
  },
  {
    q: "What do you need from me to start?",
    a: "Just your business goal, brand assets, and any account access. Kickoff happens within 48 hours of confirmation.",
  },
  {
    q: "Can you manage my ads every month?",
    a: "Absolutely — the Growth Partner package is a monthly retainer covering ads, funnels, and website improvements together.",
  },
];

export const TOOLS = ["Meta Ads", "Google Ads", "React", "Next.js", "WordPress", "SEO", "Affiliate Networks"];
